module.exports = __webpack_public_path__ + "img/germany-img.3aaa405.webp";